/*
 * Compte a rebours de l'estimation de livraison.
 *
 * Le serveur pose deja la bonne valeur dans la page : ce script ne fait que la
 * faire descendre, puis bascule sur la fourchette de dates quand l'heure de
 * coupure est passee. Une page laissee ouverte a 13h55 se met donc a jour toute
 * seule au lieu d'afficher une promesse expiree.
 *
 * Element personnalise et non script classique : la section produit est
 * rerendue par le theme a chaque changement de variante, un listener pose au
 * chargement serait perdu des le premier clic sur une taille.
 */
if (!customElements.get('delivery-countdown')) {
  customElements.define(
    'delivery-countdown',
    class DeliveryCountdown extends HTMLElement {
      /*
       * Au-dela de cet ecart on considere que c'est l'horloge du visiteur qui
       * est fausse, pas la page qui a vieilli en cache : on se recale alors sur
       * l'heure de la boutique. En dessous on garde l'horloge du visiteur, plus
       * fiable qu'un horodatage servi depuis un cache de quelques minutes.
       */
      static get maxClockDrift() {
        return 5 * 60 * 1000;
      }

      connectedCallback() {
        this.countdown = this.querySelector('[data-delivery-countdown]');
        this.dates = this.querySelector('[data-delivery-dates]');
        this.value = this.querySelector('[data-delivery-countdown-value]');
        if (!this.countdown || !this.value) return;

        this.deadline = Number(this.dataset.deadline) * 1000;
        if (!this.deadline) return;

        this.drift = Number(this.dataset.now) * 1000 - Date.now();
        if (Math.abs(this.drift) < DeliveryCountdown.maxClockDrift) this.drift = 0;

        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const remaining = this.deadline - (Date.now() + this.drift);
        if (remaining <= 0) {
          this.expire();
          return;
        }

        /*
         * Arrondi vers le bas : on n'annonce que du temps dont le client
         * dispose vraiment. Le plancher d'une minute evite le « 0 min » de la
         * derniere minute, qui se lirait comme une offre deja fermee.
         */
        const totalMinutes = Math.max(1, Math.floor(remaining / 60000));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const text =
          hours > 0
            ? hours + this.dataset.unitHour + String(minutes).padStart(2, '0')
            : totalMinutes + this.dataset.unitMinute;

        if (text !== this.value.textContent) this.value.textContent = text;
      }

      expire() {
        clearInterval(this.timer);
        this.countdown.hidden = true;
        if (this.dates) this.dates.hidden = false;
      }
    }
  );
}
